import $ from 'jquery';
import { clarify } from '@/domain/services/VueDataProvider';
import FileTypes from '@/lib/filetypes';
import { mountVueComponent } from '@/lib/mount-vue-component';
import Uploader from '@/lib/uploader.js';

export default function () {
	new FileTypes();

	// Setup the Uploader, if included on the page.
	if ($('#uploader').length > 0) {
		new Uploader(clarify(uploaderOptions));
	}

	// helpIcon
	import('@/lib/components/Shared/HelpIcon.vue').then((helpIcon) => {
		mountVueComponent('help-icon', helpIcon);
	});
}
